module.exports = __webpack_public_path__ + "a47d012c0c65ac4681db10dca44a52d0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./webserver/document_root/s/img/web/module/cookieSettings/icons-arrow-left.svg
 ** module id = 1444
 ** module chunks = 99 100
 **/